import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import InvoiceDesign from "../components/InvoiceDesign";
import "../assets/css/recu.css";

class Recu extends Component {
    state = {
        colis: [],
        formDataInvoice: null,
        isInvoiceModal: false
    }

    componentDidMount() {
        this.getColis()
    }

    async getColis() {
        const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
        const request = await axios.get("/colis/$colis.client_id$/" + user?.id)
        if (request.status === 200) this.setState({ colis: request.data })
    }

    showModalInvoice = (coli, type) => {
        const data = coli && coli !== 1 ? {
            id: coli.id,
            ref_number: coli.ref_coli,
            due: coli.invoice?.due,
            type
        } : {}

        this.setState({
            formDataInvoice: data,
            isInvoiceModal: !this.state.isInvoiceModal
        })
    }

    getStatus = (status) => {
        if (status === "Manifeste") return { label: "En transit", className: "is-transit" }
        if (status === "EnStock") return { label: "En stock", className: "is-stock" }
        return { label: status || "Traité", className: "is-delivered" }
    }

    render() {
        const colis = this.state.colis?.map((coli) => {
            const status = this.getStatus(coli.status)
            return (
                <div className="col-lg-4 col-sm-6" key={coli.id}>
                    <div className="recu-list-card">
                        <Link to={"/recus/" + coli.id} className="recu-list-card__link">
                            <div className="recu-list-card__top">
                                <span className="recu-label">Colis</span>
                                <span className={"recu-status " + status.className}><span />{status.label}</span>
                            </div>
                            <h2 className="recu-list-card__ref">{coli.ref_coli}</h2>
                            <p className="recu-list-card__meta">
                                {coli.quantity || 0} article{coli.quantity > 1 ? "s" : ""} · {coli.price || 0} $
                            </p>
                            <div className="recu-list-card__footer">
                                <span>Voir les détails</span><span>→</span>
                            </div>
                        </Link>
                        {coli.invoice?.ref_invoice && (
                            <button type="button" className="recu-list-card__invoice" onClick={() => this.showModalInvoice(coli, "FACTURE")}>
                                Facture {coli.invoice.ref_invoice}
                            </button>
                        )}
                    </div>
                </div>
            )
        })

        return (
            <div className="dashboard__content bg-light-2 recu-page">
                <div className="container">
                    <div className="items-end">
                        <div className="col-auto">
                            <span className="recu-page__eyebrow">Vos expéditions</span>
                            <h1 className="text-25 lh-14 fw-500 text-primary">Mes reçus</h1>
                            <p className="text-15 text-light-1 mt-5">Touchez un colis pour consulter toutes ses informations.</p>
                        </div>
                    </div>

                    <div className="row y-gap-20 pt-30">{colis}</div>

                    <div className="py-30 px-30 rounded-4 shadow-3">
                        <InvoiceDesign
                            showModal={this.showModalInvoice}
                            formData={this.state.formDataInvoice}
                            isModal={this.state.isInvoiceModal}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default Recu
